import axios from 'axios';
import Morphism from 'morphism';
import Ride from '../models/Ride';
import Entries from '../models/Entries';

export default class RideService {
  /**
   * Create a ride
   * @param   {Number} latitude
   * @param   {Number} longitude
   * @returns {Promise<Object>}
   */
  static create(latitude, longitude) {
    return new Promise((resolve, reject) => {
      axios.post('/api/ride', {
        latitude,
        longitude,
      }).then((response) => {
        const schema = {
          id: 'id',
          timeDriven: 'time_driven',
          timePaused: 'time_paused',
          startedInZone: 'started_in_zone',
          startedAt: 'started_at',
          endedAt: 'ended_at',
          entries: (data) => {
            if (!data.entries) {
              return null;
            }

            return Morphism({
              id: 'id',
              datetime: 'datetime',
              status: 'status',
              latitude: 'point.latitude',
              longitude: 'point.longitude',
            }, data.entries, Entries);
          },
        };

        const ride = Morphism(schema, response.data.data, Ride);

        resolve(ride);
      }).catch(reject);
    });
  }

  /**
   * Get current ride
   * @returns {Promise<Ride>}
   */
  static getRide() {
    return new Promise((resolve, reject) => {
      axios.get('/api/driver/ride')
        .then((response) => {
          const schema = {
            id: 'id',
            timeDriven: 'time_driven',
            timePaused: 'time_paused',
            startedInZone: 'started_in_zone',
            startedAt: 'started_at',
            endedAt: 'ended_at',
            entries: (data) => {
              if (!data.entries) {
                return null;
              }

              return Morphism({
                id: 'id',
                datetime: 'datetime',
                status: 'status',
                latitude: 'point.latitude',
                longitude: 'point.longitude',
              }, data.entries, Entries);
            },
          };

          const ride = Morphism(schema, response.data.data, Ride);

          resolve(ride);
        }).catch(reject);
    });
  }

  /**
   * Get rides from last 2 weeks
   * @returns {Promise<Array<Ride>>}
   */
  static getRides() {
    return new Promise((resolve, reject) => {
      axios.get('/api/ride')
        .then((response) => {
          const schema = {
            id: 'id',
            timeDriven: 'time_driven',
            timePaused: 'time_paused',
            startedInZone: 'started_in_zone',
            startedAt: 'started_at',
            endedAt: 'ended_at',
          };

          const rides = Morphism(schema, response.data.data, Ride);

          resolve(rides);
        }).catch(reject);
    });
  }
}
